import styled from "@mui/material/styles/styled";
export default styled('img')({
  width: "100%",
  height: "auto"
});
